
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.995,"time":59700,"words":199}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`首先需要下载`}<a parentName="p" {...{
        "href": "https://www.vagrantup.com/"
      }}>{`vagrantup`}</a>{`和`}<a parentName="p" {...{
        "href": "https://www.virtualbox.org/"
      }}>{`virtualbox`}</a></p>
    <h2 {...{
      "id": "vagrant常用命令"
    }}>{`Vagrant常用命令`}</h2>
    <pre><code parentName="pre" {...{}}>{`vagrant box add {title} {url} #添加一个虚拟机,{url}可以是网址，也可以指向本地的文件,{title}是虚拟机的名称可以自定
vagrant init {title}  #初始化该虚拟机
vagrant up    #启动虚拟机
vagrant halt [name]   #关闭虚拟机
vagrant box list  #列出当前导入的box
vagrant destory   #移除虚拟机
vagrant box remove [name] #移除box
vagrant status [name] #查看虚拟机的状态
vagrant ssh   #ssh连接虚拟机
`}</code></pre>
    <h2 {...{
      "id": "box的来源"
    }}>{`BOX的来源`}</h2>
    <p>{`可以自己打包box，也可以用其他人打包好的box哦，推荐一个觉得还不错的box站点`}<a parentName="p" {...{
        "href": "vagrantbox.es"
      }}>{`vagrantbox.es`}</a></p>
    <h2 {...{
      "id": "关于配置文件"
    }}>{`关于配置文件`}</h2>
    <p>{`配置文件在当前目录的Vagrantfile文件中`}</p>
    <h2 {...{
      "id": "体验过程"
    }}>{`体验过程`}</h2>
    <p>{`说道体验我们就来从头到尾走一个过程吧！安装完上面提到的两个软件，在这里面我们以Devopera CentOS 6 LAMP stack这个box为例。Let’s Go!`}</p>
    <pre><code parentName="pre" {...{}}>{`mkdir vagrant && cd vagrant
`}</code></pre>
    <p>{`   添加box：`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant box add doco6-lamp-dev http://devopera.com/node/63/download/centos6
`}</code></pre>
    <p>{`然后就会自动的用curl下载这个文件了，你也可以先下载好然后给它传入一个本地地址哈。比如这样`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant box add doco6-dj1off-dev \\\\E:\\\\doco6-dj1offr006-dev.box     #添加box
vagrant init doco6-lamp-dev #初始化
`}</code></pre>
    <p>{`这个时候目录下就会出现一个.vagrant目录和一个Vagrantfile文件`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant up #启动虚拟机
`}</code></pre>
    <p>{`如果没有报错，那么就可以通过ssh登录虚拟机了，有点激动哈！`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant ssh #ssh登录虚拟机。成功登录会显示当前虚拟机的配置信息和监听的端口号。
`}</code></pre>
    <p>{`然后就可以运行各种命令了，玩的差不多了，咱们关机吧`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant halt
`}</code></pre>
    <p>{`如果你不再使用这个虚拟机了，想要销毁使用痕迹，运行。这样下次vagrant up的时候又会重新初始化这台虚拟机咯。`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant destroy 
`}</code></pre>
    <p>{`如果你想打包这个虚拟机，那么就要用到打包命令`}</p>
    <pre><code parentName="pre" {...{}}>{`vagrant package
`}</code></pre>
    <p>{`可附带参数（原文引用）`}</p>
    <pre><code parentName="pre" {...{}}>{`--base NAME - Instead of packaging a VirtualBox machine that Vagrant manages, this will package a VirtualBox machine that VirtualBox manages. NAME should be the name or UUID of the machine from the VirtualBox GUI.
--output NAME - The resulting package will be saved as NAME. By default, it will be saved as package.box.
--include x,y,z - Additional files will be packaged with the box. These can be used by a packaged Vagrantfile (documented below) to perform additional tasks.
--vagrantfile FILE - Packages a Vagrantfile with the box, that is loaded as part of the Vagrantfile load order when the resulting box is used.
`}</code></pre>
    <p>{`那么今天初步的体验先到这里，更多体验期待就下次分享啦~`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "vagrant常用命令",
    level: 2,
    title: "Vagrant常用命令",
    children: [
        
      ]
  },
{
    id: "box的来源",
    level: 2,
    title: "BOX的来源",
    children: [
        
      ]
  },
{
    id: "关于配置文件",
    level: 2,
    title: "关于配置文件",
    children: [
        
      ]
  },
{
    id: "体验过程",
    level: 2,
    title: "体验过程",
    children: [
        
      ]
  }
]

export const frontMatter = {}

